function getMessageType(options) {
    const { message, thread } = options;
    const { sender } = message || {};
    const { interlocutor } = thread || {};
    const isSenderInterlocutor = sender.id === interlocutor.id;
    return isSenderInterlocutor ? 'receiver' : 'sender';
}
export { getMessageType };
